import { Fragment, useCallback, useRef, useState } from "react";
import Up from "../../assets/images/chevron-up.svg";
import Down from "../../assets/images/chevron-down.svg";
import { ModalPortal } from "../../components/ModalPortal";
import { CustomModal } from "../CustomModal";
import { FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import { Button } from "react-bootstrap";

const arr = [1, 2];

const addAuthorSchema = Yup.object({
  emails: Yup.array().of(
    Yup.string()
      .email("Invalid email format")
      .required("Email is required")
      .test("unique-email", "Duplicate email found", function (value) {
        const { parent } = this;
        return parent.filter((email) => email === value).length === 1; // Checks for duplicates at field level
      })
  ),
});

export const Authors = ({ bookObj }) => {
  const divRefs = useRef([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAddAuthor, setShowAddAuthor] = useState(false);

  const handleClick = (index) => {
    setCurrent(index);
    if (divRefs.current[index]) {
      divRefs.current[index].scrollIntoView({ behavior: "smooth" });
    }
  };

  const onHide = useCallback(() => {
    setShowModal(false);
  }, []);

  const onHideAuthorModal = useCallback(() => {
    setShowAddAuthor(false);
  }, []);

  const addAuthor = () => {};
  const removeAuthor = () => {};
  const onSubmit = () => {};

  return (
    <>
      <ModalPortal>
        <CustomModal
          onHide={onHide}
          loading={loading}
          showModal={showModal}
          onAction={removeAuthor}
          cancelBtnText="Go back"
          actionBtnText="Remove author"
          title="remove author access"
          content="Are you sure you want to remove this author and all access to this textbook? You can add them back at anytime."
        />
      </ModalPortal>
      <ModalPortal>
        <CustomModal
          onAction={addAuthor}
          title="add an author"
          cancelBtnText="Go back"
          actionBtnText="Continue"
          showModal={showAddAuthor}
          onHide={onHideAuthorModal}
          content="Invite an author or collaborator by email. If they do not have a Greyled account, they will be required to create one."
        >
          <Formik
            enableReinitialize
            validateOnChange={true}
            initialValues={{ emails: [""] }}
            validationSchema={addAuthorSchema}
            onSubmit={onSubmit}
          >
            {({ values, touched, errors, handleChange, handleBlur }) => (
              <Form>
                <FieldArray name="emails">
                  {({ push, remove }) => (
                    <div>
                      {values.emails.map((email, index) => (
                        <div key={index} className="d-flex flex-column gap-1">
                          <div className="d-flex align-items-center gap-1 form-group email_seaech_wrap">
                            <input
                              type="email"
                              autoComplete="off"
                              onBlur={handleBlur}
                              name={`emails[${index}]`}
                              className="form-control w-98"
                              placeholder="Invite a collaborator by email"
                              value={email}
                              onChange={handleChange}
                            />
                            {index !== 0 && (
                              <img
                                width={22}
                                height={22}
                                alt="cross ico"
                                src="/assets/images/cross.png"
                                onClick={() => remove(index)}
                                className="cursor position-absolute end-0"
                              />
                            )}
                          </div>
                          {touched.emails?.[index] &&
                            errors.emails?.[index] && (
                              <div className="invalid-feedback d-block m-0 p-0 w-100">
                                {errors.emails[index]}
                              </div>
                            )}
                        </div>
                      ))}
                      <Button
                        className="save-btn text-decoration-none m-0 p-0"
                        type="button"
                        variant="contained"
                        onClick={() => push("")}
                      >
                        + Add author
                      </Button>
                    </div>
                  )}
                </FieldArray>
                {/* <div className="mt-4">
                  <Button type="submit" variant="contained" color="primary">
                    Submit
                  </Button>
                </div> */}
              </Form>
            )}
          </Formik>
        </CustomModal>
      </ModalPortal>
      <div className="d-flex justify-content-between w-72">
        <div className="d-flex align-items-center gap-2">
          <span className="book_detail_author_tab_title text-uppercase">
            original authors indicated with
          </span>
          <img
            src="/assets/images/yellow_star.svg"
            alt="star icon here"
            width={20}
            height={20}
          />
        </div>
        <div className="d-flex align-items-center gap-2 book_detail_author_tab_title text-uppercase">
          <button
            className="cursor save-btn rounded-0 text-decoration-none"
            onClick={() => setShowAddAuthor(true)}
          >
            Add Author --&gt;
          </button>
        </div>
      </div>
      {arr.map((item, index) => (
        <Fragment key={index}>
          <div
            className="d-flex gap-2"
            ref={(el) => (divRefs.current[index] = el)}
          >
            <div className="d-flex flex-column align-items-center gap-1 pt-2 w-18">
              {current === index && (
                <>
                  {index !== 0 && (
                    <img
                      className="cursor"
                      src={Up}
                      alt="up icon here"
                      onClick={() => handleClick(index - 1)}
                    />
                  )}
                  <span className="fw-bold">{index + 1}</span>
                  {index !== arr.length - 1 && (
                    <img
                      className="cursor"
                      src={Down}
                      alt="up icon here"
                      onClick={() => handleClick(index + 1)}
                    />
                  )}
                </>
              )}
            </div>
            <div className="d-flex flex-column gap-3 border-grey rounded-1 p-3 py-20 w-70">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center justif-content-center gap-3">
                  <img
                    src="/assets/images/yellow_star.svg"
                    alt="star icon here"
                  />
                  <h3 className="text-dark-grey fs-20 fw-500 fst-normal ls-06 m-0">
                    Dr. Evelyn Sterling, Cambridge University
                  </h3>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <label className="d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      className="customized_checkbox"
                      disabled={current !== index}
                    />
                    Show name on Greyled
                  </label>
                  <img
                    width={20}
                    height={20}
                    className="cursor"
                    src="/assets/images/edit.svg"
                    alt="edit icon here"
                    onClick={() => setShowModal(true)}
                  />
                  <img
                    width={20}
                    height={20}
                    className="cursor"
                    src="/assets/images/confirm_delete.svg"
                    alt="confirm delete icon here"
                    onClick={() => setShowModal(true)}
                  />
                </div>
              </div>
              <div className="d-flex">
                <input
                  type="text"
                  name="title"
                  placeholder="Title of the textbook"
                  className="form-control pl_0 book_detail_overview_title mb-0 black_divider_line_width"
                />
              </div>
            </div>
          </div>
        </Fragment>
      ))}
    </>
  );
};
